import PersonIcon from "@mui/icons-material/Person";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import PeopleIcon from "@mui/icons-material/People";
import Diversity2Icon from "@mui/icons-material/Diversity2";

export const HrmsSideBarList = [
  {
    text: "Dashboard",
    icons: DashboardCustomizeIcon,
    link: "/HrManagement/dashboard",
  },
  {
    text: "Users",
    icons: PeopleIcon,
    link: "/HrManagement/users",
  },
  {
    text: "Attendance",
    icons: TaskAltIcon,
    link: "/HrManagement/attendance",
    customLink: "/HrManagement/individualAtt",
  },
  {
    text: "Leaves",
    icons: PersonIcon,
    link: "/HrManagement/leaves",
  },
  {
    text: "Interview",
    icons: Diversity2Icon,
    link: "/HrManagement/interview",
  },
  {
    text: "Payroll",
    icons: Diversity2Icon,
    children: [
      {
        text: "Departments",
        icons: Diversity2Icon,
        link: "/HrManagement/payroll/department",
      },
      {
        text: "Shifts",
        icons: Diversity2Icon,
        link: "/HrManagement/shift",
      },
      {
        text: "Off Days",
        icons: Diversity2Icon,
        link: "/HrManagement/offDays",
      },
      {
        text: "Allowances",
        icons: Diversity2Icon,
        link: "/HrManagement/allowance",
      },
      {
        text: "Public Holidays",
        icons: Diversity2Icon,
        link: "/HrManagement/holidays",
      },
      {
        text: "Salaries",
        icons: Diversity2Icon,
        link: "/HrManagement/salary-slips",
      },
    ],
  },
];
